import SidebarMPAContent from './SidebarMPAContent';

export default SidebarMPAContent;
